import React from "react";
import { Dialog, DialogActions, DialogContent, Button, DialogTitle, makeStyles } from "@material-ui/core";
import { logout } from '../../store/actions/account.actions';
import { useDispatch } from 'react-redux';
import { signOut, useUserDispatch } from '../../context/UserContext';
import { useMsal } from '@azure/msal-react';
import { logoutUser } from "../../store/actions/logon.actions";

const useStyles = makeStyles(() => ({
    dialogPaper: {
        borderRadius: "18px",
        boxShadow: "0 8px 40px rgba(60,60,60,0.18)",
        padding: "0 0 8px 0"
    },
    heading: {
        fontSize: "2.3rem", // bigger font
        fontWeight: 700,
        color: "#c22332",
        margin: "0 0 12px 0",
        textAlign: "center",
        letterSpacing: "1px"
    },
    content: {
        fontSize: "1.3rem", // bigger font
        fontWeight: 500,
        textAlign: "center",
        color: "#444",
        padding: "28px 32px 0 32px",
        lineHeight: 1.5
    },
    actions: {
        display: "flex",
        justifyContent: "center",
        padding: "32px 0 28px 0"
    },
    createButton: {
        backgroundColor: "#1A9FE0",
        minWidth: 160,
        fontWeight: 800,
        textTransform: "inherit",
        fontFamily: "Nunito",
        fontSize: "1rem",
        color: "#FFFFFF",
        borderRadius: "2.5rem",
        height: 44,
        boxShadow: "0 2px 8px rgba(52,152,219,0.11)"
    },
    logoutButton: {
        minWidth: 140,
        borderRadius: "2.5rem",
        height: 44,
        fontWeight: 700,
        fontFamily: "Nunito",
        fontSize: "1rem",
        textTransform: "capitalize",
        color: "#1A9FE0",
        border: "2px solid #1A9FE0",
        marginLeft: 20,
        background: "#fff",
        transition: "background 0.2s, color 0.2s",
        "&:hover": {
            background: "#1A9FE0",
            color: "#fff",
            border: "2px solid #1A9FE0"
        },
        "&:disabled": {
            color: "#b5d5ea",
            border: "2px solid #b5d5ea",
            background: "#fafcff"
        }
    }
}));

export default function PricingTierDowngradeDialog({ open, handleopenClose }: { open: boolean; handleopenClose: (value: boolean) => void }) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [loading, setLoading] = React.useState(false);
    const userDispatch = useUserDispatch();
    const { instance } = useMsal();

    const callLogout = async () => {
        setLoading(true);
        await dispatch(logoutUser());
        await dispatch(logout());
        signOut(userDispatch);
        setLoading(false);
        instance.logoutRedirect({ postLogoutRedirectUri: "/" });
    };

    return (
        <Dialog
            open={open}
            aria-labelledby="pricing-tier-dialog-title"
            fullWidth
            maxWidth="md"
            classes={{ paper: classes.dialogPaper }}
            disableBackdropClick
            disableEscapeKeyDown
        >
            <DialogTitle id="pricing-tier-dialog-title">
                <div className={classes.heading}>Notice</div>
            </DialogTitle>
            <DialogContent>
                <div className={classes.content}>
                   Kindly click on Refresh button for new updates
                </div>
            </DialogContent>
            <DialogActions className={classes.actions}>
                <Button
                    variant="contained"
                    className={classes.createButton}
                    color="primary"
                    onClick={() => window.location.reload()}
                >
                    Refresh
                </Button>
                <Button
                    disabled={loading}
                    className={classes.logoutButton}
                    variant="outlined"
                    onClick={callLogout}
                >
                    Logout
                </Button>
            </DialogActions>
        </Dialog>
    );
}
